import MapView from "../map/MapView";
import {AppActions, useAppContext} from "../../context/AppContext";
import {useEffect, useState} from "react";
import {v4} from "uuid";

export default function MapTab({}) {
    const type = 'base'
    const [projectInfo, setProjectInfo] = useState({});
    const {selectedHistoryId, getSelectedHistory, dispatchProject, getSelectedRS, mapContext, getProjectLayers, getRiverBoundingCoords, getMapData, appContext} = useAppContext()

    useEffect(() => {
        const selection = getSelectedHistory()?.selection[type]
        setProjectInfo({
            title: `${selection?.project?.information?.title} (${selection?.project?.information?.folderName})`,
            plan: `${selection?.plan?.type} (.${selection?.plan?.plan?.ext})`,
            river: selection?.river?.river ? `${selection?.river?.river} - ${selection?.river?.reach}` : '',
        })
    }, [selectedHistoryId]);

    return (
        <>
            <MapView
                type={'base'}
                projection={getSelectedHistory()?.selection[type]?.project?.projection?.text}
                filter={getSelectedHistory()?.page}
                projectInfo={projectInfo}
                updateKey={selectedHistoryId}
                mapData={getMapData(type)}
                projectLayers={getProjectLayers(type)}
                riverBoundingCoords={getRiverBoundingCoords(type)}
                selectedRS={getSelectedRS()}
                onProjectLayerChange={(shapes) => {
                    const _project = appContext?.projects?.find(x => x.id === getSelectedHistory()?.selection[type]?.project?.id)
                    if (_project) {
                        _project.shapes = [...shapes]
                        dispatchProject({
                            type: AppActions.SET_PROJECT,
                            data: {
                                project: {
                                    ..._project
                                },
                                map: {
                                    type,
                                    [type]: {
                                        update: v4()
                                    }
                                }
                            }
                        })
                    }
                }}
            />
        </>
    )
}